import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';

export default function ConfirmaEmailPage() {
  const [searchParams]      = useSearchParams();
  const navigate            = useNavigate();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [msg, setMsg]       = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) { setStatus('error'); setMsg('Link invalid — lipsește token-ul.'); return; }

    authAPI.confirmaEmail(token)
      .then(() => {
        setStatus('success');
        setTimeout(() => navigate('/login?confirmat=1'), 2500);
      })
      .catch(err => {
        setStatus('error');
        setMsg(err.response?.data?.message || 'Link invalid sau expirat.');
      });
  }, []);

  const css = `
    .ce-page { min-height:100vh; display:flex; align-items:center; justify-content:center; background:#f5f5f7; padding:20px; }
    .ce-card { background:#fff; border-radius:16px; padding:48px 40px; text-align:center; max-width:420px; width:100%; box-shadow:0 4px 24px rgba(0,0,0,0.08); }
    @media(max-width:599px){ .ce-page{padding:0;align-items:flex-start} .ce-card{border-radius:0;min-height:100vh;box-shadow:none;padding:40px 20px} }
  `;

  return (
    <>
      <style>{css}</style>
      <div className="ce-page">
        <div className="ce-card">
          {status === 'loading' && (
            <>
              <div style={{ fontSize: 48, marginBottom: 16 }}>⏳</div>
              <h2 style={{ color: '#1a1a2e', margin: '0 0 8px' }}>Se verifică link-ul...</h2>
              <p style={{ color: '#888', fontSize: 14 }}>Te rugăm să aștepți.</p>
            </>
          )}
          {status === 'success' && (
            <>
              <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
              <h2 style={{ color: '#059669', margin: '0 0 8px' }}>Cont activat!</h2>
              <p style={{ color: '#555', fontSize: 14 }}>Contul tău este activ. Ești redirecționat la login...</p>
            </>
          )}
          {status === 'error' && (
            <>
              <div style={{ fontSize: 48, marginBottom: 16 }}>❌</div>
              <h2 style={{ color: '#dc2626', margin: '0 0 8px' }}>Link invalid</h2>
              <p style={{ color: '#555', fontSize: 14, marginBottom: 24 }}>{msg}</p>
              <button onClick={() => navigate('/login')}
                style={{ padding: '12px 24px', background: '#2d2d7e', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>
                Înapoi la login
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
}
